import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import UserProgressContext from "../../userProgressContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCircleQuestion,
  faScrewdriverWrench,
  // faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
// import TaskDescriptionModal from "../Modal/taskDescriptionModal";
import HelpModal from "../Modal/helpModal";
import ControlRoomNetwork from "./controlRoomNetwork";
import Terminal from "./terminal";
import SubstationNetwork from "./substationNetwork";
import SoundManager from "../../services/SoundManager";
import { saveUserProgress } from "../../services/saveUserProgress";

const CyberChallenge = ({ script }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const {
    audioMuted,
    name,
    emailId,
    localProgress,
    currentTool,
    redeemedScores,
    finishedTasks,
    setFinishedTasks,
  } = useContext(UserProgressContext);
  // const [isTaskModalVisible, setIsTaskModalVisible] = useState(false);
  const [isHelpModalVisible, setIsHelpModalVisible] = useState(false);
  const [isTaskCompleted, setIsTaskCompleted] = useState(false);

  const hasInvokedSaveUserProgress = useRef(false);
  let previousLocationPathname = undefined;
  if (location && location.state) {
    const state = location.state;
    if (state.previousLocationPathname)
      previousLocationPathname = state.previousLocationPathname;
  }
  useEffect(() => {
    if (!previousLocationPathname) navigate("/page-not-found");
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (
      script &&
      localProgress &&
      script[localProgress] &&
      "taskId" in script[localProgress] &&
      finishedTasks &&
      finishedTasks.has(script[localProgress]["taskId"].toString())
    ) {
      hasInvokedSaveUserProgress.current = false;
      setIsTaskCompleted(true);
    }
  }, [script, finishedTasks]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (
      currentTool &&
      script &&
      localProgress &&
      script[localProgress] &&
      "ggaTool" in script[localProgress] &&
      script[localProgress]["ggaTool"] === currentTool
    ) {
      // setIsToolSelected(true);
      if ("taskId" in script[localProgress]) {
        const newFinishedTasksSet = new Set(
          finishedTasks.add(script[localProgress]["taskId"])
        );
        const handleProgressUpdate = () => {
          if (emailId && name) {
            saveUserProgress({
              name: name,
              emailId: emailId,
              redeemedScores: redeemedScores,
              finishedTasks: newFinishedTasksSet,
            });
            hasInvokedSaveUserProgress.current = true;
          }
        };
        setTimeout(() => {
          if (!hasInvokedSaveUserProgress.current) handleProgressUpdate();
        }, 200);
        setFinishedTasks(newFinishedTasksSet);
      }
    }
  }, [currentTool]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    // Query after DOM commit so we never close over a null reference.
    const btnNext = document.getElementById("btnNext");
    if (btnNext) {
      if (isTaskCompleted) {
        // console.log("inside cyberChallenge useEffect 3.1");
        btnNext.disabled = false;
        btnNext.style.cursor = "pointer";
        btnNext.style.opacity = "1";
        btnNext.title = "";
      } else {
        btnNext.disabled = true;
        btnNext.style.cursor = "not-allowed";
        btnNext.style.opacity = "0.5";
        btnNext.title = "You must complete the task before proceeding";
      }
    }
    return () => {
      const btnNext = document.getElementById("btnNext");
      if (btnNext) {
        btnNext.disabled = false;
        btnNext.style.cursor = "pointer";
        btnNext.style.opacity = "1";
        btnNext.title = "";
      }
    };
  }, [isTaskCompleted]); // eslint-disable-line react-hooks/exhaustive-deps
  // const openTaskModal = () => {
  //   setIsTaskModalVisible(true);
  // };
  // const closeTaskModal = () => {
  //   setIsTaskModalVisible(false);
  // };

  const openHelpModal = () => {
    SoundManager.playSfx('game-secondary-click');
    setTimeout(() => {
      setIsHelpModalVisible(true);
    }, 100);
  };

  const closeHelpModal = () => {
    SoundManager.playSfx('game-secondary-click');
    setIsHelpModalVisible(false);
  };
  return (
    <React.Fragment>
      {script && script[localProgress] && (
        <div className="flex flex-col text-black bg-white py-1 shadow-xl shadow-orange-900 w-full h-full">
          <div className="flex justify-between overflow-x-hidden">
            {"task" in script[localProgress] && (
              <div
                className={`rounded-lg text-white ${
                  isTaskCompleted ? "bg-green-500" : "bg-orange-400"
                } text-xl flex items-center gap-2 w-max px-6 py-2 -ml-4`}
              >
                <FontAwesomeIcon
                  icon={!isTaskCompleted ? faScrewdriverWrench : faCheck}
                />
                <h1 className="text-base">
                  Task: {script[localProgress]["task"]}
                </h1>
              </div>
            )}
            {!isTaskCompleted && "character" in script[localProgress] && (
              <div className="p-2">
                <button title="Help" onClick={openHelpModal}>
                  <FontAwesomeIcon
                    icon={faCircleQuestion}
                    className="text-indigo-500 text-2xl cursor-pointer hover:scale-105 transition-all ease-out duration-100"
                  />
                </button>
                <HelpModal
                  isVisible={isHelpModalVisible}
                  onClose={closeHelpModal}
                  script={script[localProgress.toString()]}
                />
              </div>
            )}
          </div>
          {"taskId" in script[localProgress] &&
            (script[localProgress]["taskId"] === "3.1" ||
              script[localProgress]["taskId"] === "3.3" ||
              script[localProgress]["taskId"] === "3.4") && (
              <ControlRoomNetwork
                currentScript={script[localProgress]}
                isTaskCompleted={isTaskCompleted}
                audioMuted={audioMuted}
              />
            )}
          {"taskId" in script[localProgress] &&
            script[localProgress]["taskId"] === "3.2" && (
              <div className="relative flex items-center justify-center mt-4 w-full h-full">
                <Terminal
                  isTaskCompleted={
                    finishedTasks &&
                    finishedTasks.has(
                      script[localProgress]["taskId"].toString()
                    )
                  }
                />
              </div>
            )}
          {"taskId" in script[localProgress] &&
            (script[localProgress]["taskId"] === "5.1" ||
              script[localProgress]["taskId"] === "5.2" ||
              script[localProgress]["taskId"] === "5.3" ||
              script[localProgress]["taskId"] === "5.4" ||
              script[localProgress]["taskId"] === "5.5" ||
              script[localProgress]["taskId"] === "5.6") && (
              <div className="relative flex items-center justify-center mt-4 w-full h-full">
                <SubstationNetwork
                  currentScript={script[localProgress]}
                  isTaskCompleted={
                    finishedTasks &&
                    finishedTasks.has(
                      script[localProgress]["taskId"].toString()
                    )
                  }
                />
              </div>
            )}
        </div>
      )}
    </React.Fragment>
  );
};

export default CyberChallenge;
